<app-header [back]="['/']"></app-header>
<app-page-box class="fade-in-with-delay">
	@if (selector && selector.loading) {
		<div class="spin-container">
			<nz-spin nzSimple nzSize="large"></nz-spin>
		</div>
	}

	<div>
		@if (sections().length === 0) {
			<div class="no-sections-found">
				<h1>No classes assigned yet.</h1>
				<h2>Please check back later.</h2>
			</div>
		}

		<div>
			@if (sections().length > 0) {
				<app-course-title>My Classes</app-course-title>
			}

			<app-journey-section-selector
				(onSectionSelected)="onSectionSelected($event)"
				(onSectionsLoaded)="onSectionsLoaded($event)"
				#selector
			></app-journey-section-selector>
		</div>

		@if (selector) {
			<app-quick-enroll (enrollInSection)="selector.reloadSections()"></app-quick-enroll>
			@if (isSelfRosteringAllowed()) {
				<div class="self-roster-container">
					<app-section-self-roster (onSectionsChanged)="selector.reloadSections()"></app-section-self-roster>
				</div>
			}
		}
	</div>
</app-page-box>
